"use client"
import { usePathname as useNextPathname } from "next/navigation"
import { pathnameExtract } from "./pathname-extract"

export function usePathname() {
  const pathname = useNextPathname()
  return pathnameExtract(pathname).rest
}
